const _isDebugEnabled =
  typeof window !== "undefined" &&
  window.location.hostname !== "recipal.com" &&
  window.railsEnv !== "test";

export function debugLog(...args) {
  if (_isDebugEnabled) {
    console.debug(...args);
  }
}
